export const STAGE_META = {
  new:               { emoji: '🔗', label: 'New link',          cls: 'bg-[#EBF3FA] text-[#1E568B] border-[#C9DEFA]', dot: '#3B82F6' },
  in_visuals:        { emoji: '🎨', label: 'In visuals',        cls: 'bg-[#F3E8FF] text-[#6B21A8] border-[#E9D5FF]', dot: '#A855F7' },
  in_review:         { emoji: '👀', label: 'In review',         cls: 'bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]', dot: '#F59E0B' },
  changes_requested: { emoji: '🔁', label: 'Changes requested', cls: 'bg-[#FFE4E6] text-[#9F1239] border-[#FECDD3]', dot: '#F43F5E' },
  approved:          { emoji: '✅', label: 'Approved',          cls: 'bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]', dot: '#6366F1' },
  live_on_etsy:      { emoji: '🛍️', label: 'Live on Etsy',      cls: 'bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]', dot: '#10B981' },
  done:              { emoji: '🎉', label: 'All channels done', cls: 'bg-[#F0FDF4] text-[#166534] border-[#BBF7D0]', dot: '#22C55E' },
};

export const PIPELINE_FLOW = ['new', 'in_visuals', 'in_review', 'changes_requested', 'approved', 'live_on_etsy', 'done'];

export const CHANNEL_META = {
  tlj:       { emoji: '💎', label: 'TLJ website',    mp: 'tlj' },
  ebay:      { emoji: '📦', label: 'eBay',           mp: 'ebay' },
  walmart:   { emoji: '🏬', label: 'Walmart',        mp: 'walmart' },
  amazon:    { emoji: '🛒', label: 'Amazon',         mp: 'amazon' },
  pinterest: { emoji: '📌', label: 'Pinterest',      mp: 'pinterest' },
  resellers: { emoji: '🤝', label: 'Resellers / FB', mp: 'resellers' },
};
export const CHANNEL_ORDER = Object.keys(CHANNEL_META);

export const CHANNEL_STATUS = {
  done:        { emoji: '✅', label: 'Done',        cls: 'bg-[#EBF5F0] text-[#2B6F52] border-[#C5E3D5]' },
  skipped:     { emoji: '⏭️', label: 'Skipped',     cls: 'bg-[#F7F3EC] text-[#9A8E85] border-[#E8E1D5] line-through' },
  in_progress: { emoji: '⏳', label: 'In progress', cls: 'bg-[#FFF8EC] text-[#92400E] border-[#F6E3C0]' },
  pending:     { emoji: '⚪', label: 'To do',       cls: 'bg-white text-[#6E635B] border-[#E8E1D5]' },
};

export const PRODUCT_TYPES = [
  { value: 'engagement_ring',     label: 'Engagement ring', emoji: '💍' },
  { value: 'engagement_ring_set', label: 'Ring set',        emoji: '💞' },
  { value: 'wedding_band',        label: 'Wedding band',    emoji: '💫' },
  { value: 'pendant_studs',       label: 'Pendant / studs', emoji: '✨' },
  { value: 'tennis_bracelet',     label: 'Tennis bracelet', emoji: '💎' },
  { value: 'tennis_necklace',     label: 'Tennis necklace', emoji: '📿' },
];
export const productTypeEmoji = (t) => PRODUCT_TYPES.find((p) => p.value === t)?.emoji || '💍';

const pad = (n) => String(n).padStart(2, '0');
export const dayKey = (iso) => {
  if (!iso) return '0000-00-00';
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
export const todayKey = () => dayKey(new Date().toISOString());
export const shiftDayKey = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return dayKey(d.toISOString());
};
const keyToDate = (key) => {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y, m - 1, d);
};
export const dayLabel = (key) => {
  if (key === todayKey()) return 'Today';
  if (key === shiftDayKey(-1)) return 'Yesterday';
  return keyToDate(key).toLocaleDateString('en-IN', { weekday: 'long' });
};
export const dayDate = (key) => keyToDate(key).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

export const timeAgo = (iso) => {
  if (!iso) return '';
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
};

export const latestComment = (wf, kind) =>
  [...(wf?.comments || [])].reverse().find((c) => !kind || c.kind === kind);

export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;
